export function getMarkupPrice(markupType, markupValue, itemPrice) {
    switch(markupType) {
        case "added_percentage":
          return itemPrice * markupValue;
        case "no_markup":
          return 0;
        case "fixed_profit":
          return markupValue;
        case "fixed_price":
          return markupValue - itemPrice;
        default:
          return 0;
      }
}

export function updateItemMarkup(item, markupParams, orderTestSupportObj) {
  const { markup, customizedTestName } = markupParams;
  let markupDiff = markup - (item.markupPrice ? item.markupPrice : 0);
  item.markupPrice = markup;
  item.markupVersion = 0;
  if (markupDiff === 0) {
    return;
  }
  if (customizedTestName) {
    item.customizedName = customizedTestName
  }
  // if item is test, update its parents' markup as well
  if (["va", "vw"].includes(item.category)) {
    let { testNodeList } = orderTestSupportObj;
    let itemNode = testNodeList.find(node => node.id === item.id);
    while(itemNode.parent) {
      itemNode = itemNode.parent;
      if (itemNode.value.markupPrice && itemNode.value.markupVersion > -1) {
        continue;
      }
      let { markupPrice } = itemNode.value;
      itemNode.value.markupPrice = (markupPrice ? markupPrice : 0) + markupDiff;
      itemNode.value.markupVersion = -1;
    }
  }
}